import { api } from 'services/api'

export const cadastrarCliente = async ({ data }) => {
  const url = 'clientes'
  const response = await api.post(url, { data })
  return response.data
}
